import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { EcoChallengeFileModel } from '../models/eco-challenge-file.model';

export class EcoChallengeFilesApiService extends ApiService {
  static endpoint = 'eco-challenge-files';

  /**
   * @param {string | number} id
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async get(id, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(id), {
      ...config,
      dataModel: EcoChallengeFileModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<EcoChallengeFileModel>>}
   * @public
   */
  static async getAll(builderCallback = null, config = {}, ) {
    return HttpApiClient.get(this.buildUrl(),{
      ...config,
      dataModel: EcoChallengeFileModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<EcoChallengeFileModel>>}
   * @public
   */
  static async post(data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      dataModel: EcoChallengeFileModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
